
































import Vue from 'vue'
import store from '@/store'
import Loader from '@/components/Common/Loader.vue'
import DataTableBody from '@/components/DataTable/DataTableBody.vue'
import KanbanColumnSetting from '@/components/DataTable/Kanban/KanbanColumnSetting.vue'
import PaginationBlock from '@/components/DataTable/Pagination/PaginationBlock.vue'
import EmptyResult from '@/components/EmptyResult/EmptyResult.vue'
import {
  CheckboxValue,
  DataTablePayload,
  TableSetting,
} from '@/models/dataTable'
import { RecordingsActionTypes } from '@/store/modules/recordings/actions'
import { DataTableResponse, RecordingColumnItem } from '@/models/scripts'
import { mapGetters } from 'vuex'

interface Props {
  keyName: string
  column: string
  tableSetting: TableSetting
  title: string
}

interface Data {
  param: DataTablePayload
  showLoader: boolean
  checkedItems: CheckboxValue[]
  notEmpty: boolean
  kanbanTableSetting: TableSetting
}

interface Methods {
  getRecording: () => Promise<void>
  setFilter: () => void
  setLimit: () => void
  setOffset: () => void
  setColumns: () => void
}
interface Computed {
  kanbanRecordings: { [key: string]: { [key: string]: DataTableResponse } }
  tableId: string
  tableDataColumns: RecordingColumnItem[] | undefined
  showColumn: boolean
}

export default Vue.extend<Data, Methods, Computed, Props>({
  components: {
    Loader,
    PaginationBlock,
    DataTableBody,
    EmptyResult,
    KanbanColumnSetting,
  },
  props: {
    keyName: {
      required: true,
    },
    column: {
      required: true,
    },
    tableSetting: {
      required: true,
    },
    title: {
      required: true,
    },
  },
  data() {
    return {
      param: {
        limit: 20,
        offset: 0,
        expand: '',
        filter: '',
        sort: '',
      },
      showLoader: false,
      checkedItems: [],
      notEmpty: false,
      kanbanTableSetting: {
        enableFilters: false,
        enableRowInfo: true,
        directory: this.tableSetting.directory,
        showLoader: true,
        enableChecking: false,
        view: this.tableSetting.view,
      },
    }
  },
  methods: {
    async getRecording() {
      this.kanbanTableSetting.showLoader = true
      this.notEmpty = false
      await store.dispatch(RecordingsActionTypes.LoadKanbanItem, {
        ...this.param,
        keyName: this.keyName,
        column: this.column,
      })
      this.notEmpty =
        Object.keys(
          this.kanbanRecordings[this.keyName][String(this.column)].data,
        ).length > 0
      this.kanbanTableSetting.showLoader = false
    },
    setFilter() {
      this.param.filter = `${this.keyName}:E${this.column}`
    },
    setLimit() {
      if (this.$route.query[`limit${this.tableId}`]) {
        return (this.param.limit = Number(
          this.$route.query[`limit${this.tableId}`],
        ))
      }
      this.param.limit = 20
    },
    setOffset() {
      if (this.$route.query[`offset${this.tableId}`]) {
        this.param.offset = Number(this.$route.query[`offset${this.tableId}`])
        return this.getRecording()
      }

      this.param.offset = 0
    },
    setColumns() {
      if (this.$route.query[`columns${this.tableId}`]) {
        this.param.expand = this.$route.query[
          `columns${this.tableId}`
        ] as string
        return this.getRecording()
      }
    },
  },
  computed: {
    ...mapGetters({ kanbanRecordings: 'getKanbanRecordings' }),
    tableId() {
      return this.keyName + this.column
    },
    tableDataColumns() {
      return this.kanbanRecordings[this.keyName][this.column]?.columns?.filter(
        (elem: RecordingColumnItem) => elem.visible,
      )
    },
    showColumn() {
      return !!(
        this.notEmpty &&
        !this.kanbanTableSetting.showLoader &&
        this.kanbanRecordings[this.keyName][this.column]?.columns
      )
    },
  },
  created() {
    this.setFilter()
    this.setLimit()
    this.setOffset()
    this.setColumns()
    this.getRecording()
  },
  watch: {
    '$route.query'(oldValue, newValue) {
      if (
        oldValue[`limit${this.tableId}`] !== newValue[`limit${this.tableId}`]
      ) {
        this.setLimit()
        this.getRecording()
      }
      if (
        oldValue[`offset${this.tableId}`] !== newValue[`offset${this.tableId}`]
      ) {
        this.setOffset()
        this.getRecording()
      }
      if (
        oldValue[`columns${this.tableId}`] !==
        newValue[`columns${this.tableId}`]
      ) {
        this.setColumns()
        this.getRecording()
      }
    },
  },
})
